import React, { Component } from 'react';
import { Link } from "react-router-dom";
import logo  from '../logo.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
//import Button from '@material-ui/core/Button';
//import Hidden from '@material-ui/core/Hidden';

import { ButtonContainer } from "./Button";


export default class Navbar extends Component {
    render() {
        return (
            <NavWrapper className="navbar navbar-expand-sm navbar-dark px-lg-5">
                <div className={"nav-spacer"}>
                <Link to="/">
                    <img src={logo} alt="store" className="navbar-brand"/>
                </Link>
                <ul className="navbar-nav align-items-center">
                    <li className="nav-item">
                        <Link to="/" className="nav-link">
                            WeWinGlobe
                        </Link>
                    </li>
                </ul>
                </div>
                <div className={"nav-spacer"}>
             <Link  to="/" className="ml-auto d-none d-sm-block text-decoration-none"  >
             <ButtonContainer className="d-none d-sm-block" >
                 Home
             </ButtonContainer>
             </Link>
                <Link to="/Cart" >
                    <ButtonContainer>
                        <span className="mr-2 ml-2">
                            <FontAwesomeIcon icon="cart-plus"/>
                        </span> <span>my cart</span>
                    </ButtonContainer>
                </Link>
                </div>
            </NavWrapper>
        )
    }
}


const NavWrapper = styled.nav`
background: var(--mainBlue);
display: flex;
flex-direction: row;
justify-content: space-between;
.nav-link {
    color: var(--mainWhite) !important;
    font-size: 1.3rem !important;
    text-transform: capitalize !important;
}
`



